/**
 * The clamp, in CSS pixels. Repeated in `genre-pack.module.css`: a `max-block-size` the element is
 * not currently honouring cannot be read back out of the computed style.
 */
export const GENRE_PACK_CLAMP_PX = 475;

/* Worst-case mobile geometry for a pack's two logo grids, from `genre-pack.module.css` and
   `logo-grid.module.css` at a 320px viewport (260px of content after the 30px insets). Every
   figure rounds UP, so a pack this calls fitting cannot overflow at any width the clamp applies. */
const CONTENT_PX = 260;
const COLUMN_GAP_PX = 16;
const ROW_GAP_PX = 8;
const HEADING_PX = 48 + 8;
const BODY_GAP_PX = 16;
const SUBSCRIPTION = {
  tile: 44,
  cell: 44,
  paddingBlock: 6
};
/* A channel cell is its 54px disc plus a Local/RSN badge under it; every cell is assumed badged. */
const CHANNEL = {
  tile: 54,
  cell: 54 + 4 + 24,
  paddingBlock: 0
};

function gridHeight(count: number, shape: { tile: number; cell: number; paddingBlock: number }): number {
  if (count === 0) {
    return 0;
  }
  const perRow = Math.max(1, Math.floor((CONTENT_PX + COLUMN_GAP_PX) / (shape.tile + COLUMN_GAP_PX)));
  const rows = Math.ceil(count / perRow);
  return HEADING_PX + shape.paddingBlock * 2 + rows * shape.cell + (rows - 1) * ROW_GAP_PX;
}

/**
 * GP12 — true when a pack's logos provably fit under the clamp, so the server can render it
 * without a Show More row and the measurement has nothing to take away after hydration. False
 * means "unknown", not "overflows": the client measurement still decides those.
 */
export function packProvablyFits(subscriptionCount: number, channelCount: number): boolean {
  const subscriptions = gridHeight(subscriptionCount, SUBSCRIPTION);
  const channels = gridHeight(channelCount, CHANNEL);
  const gap = subscriptions > 0 && channels > 0 ? BODY_GAP_PX : 0;
  return subscriptions + channels + gap <= GENRE_PACK_CLAMP_PX;
}
